export const convertBooleanToString = (value) => {
  if (value === true || value === "true") return "Yes";
  if (value === false || value === "false") return "No";
  return value;
};

const isEmptyValue = (value) => {
  if (value === "" || value === null || value === undefined) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  return false;
};

export const isFormEmpty = (data) => {
  if (!data || typeof data !== "object") return true;
  return Object.values(data).every(isEmptyValue);
};

export const sanitizeHourlyRate = (value) =>
  Math.max(0, Number(value) || 0);
